var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburger3232 = function SvgHamburger3232(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#F8F9FA",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A0A0A",
    fillRule: "evenodd",
    d: "M8.5 11.833c0-.345.258-.625.577-.625h13.846c.319 0 .577.28.577.625s-.258.625-.577.625H9.077c-.319 0-.577-.28-.577-.625M8.5 16c0-.345.258-.625.577-.625h13.846c.319 0 .577.28.577.625s-.258.625-.577.625H9.077c-.319 0-.577-.28-.577-.625M8.5 20.167c0-.346.258-.625.577-.625h13.846c.319 0 .577.28.577.625s-.258.625-.577.625H9.077c-.319 0-.577-.28-.577-.625",
    clipRule: "evenodd"
  })));
};
export default SvgHamburger3232;